import { render } from "./RegisterOrUploadTemplate.vue?vue&type=template&id=074cdcbe&scoped=true"
import script from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"

import "./RegisterOrUploadTemplate.vue?vue&type=style&index=0&id=074cdcbe&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074cdcbe"]])

export default __exports__